module.exports = __webpack_public_path__ + "img/operate_list1.3db30bab.png";